export const DEFAULT_FOCAL_POINTS = {
	x: 0.5,
	y: 0.5,
};

export const BACKGROUND_IMAGE_POSITIONS = {
	"left top": "0% 0%",
	"left center": "0% 50%",
	"left bottom": "0% 100%",
	"center top": "50% 0%",
	"center center": "50% 50%",
	"center bottom": "50% 100%",
	"right top": "100% 0%",
	"right center": "100% 50%",
	"right bottom": "100% 100%",
};

export const BACKGROUND_IMAGE_SIZES = ["default", "contain", "cover", "fill"];
